import { HttpService } from '../../services/HttpService';
import { getSecureBaseUrl } from '../../services/UrlMapperService';
import * as Constants from './Constants';
import { apiUrls } from '../../constants/apiUrl';
import { logError, FE_API_ERROR } from '../../services/loggerService';
import {
  getAPPID,
  setSession,
  getSession,
  isBulkQualIndicator,
  getIntendType,
  isSequentialFlow,
  isWHW,
  setCookie,
  getCookie,
  isJointTransactionFlow,
  isWHWP2,
  isWWM,
  skipProspectExpressCheckout,
} from '../../components/common/Helpers';
import { hideLoader } from '../../components/common/Loader/action';
import { store } from '../../configureStore';
import { saveItemToStore } from '../../utils/sessionStorage';
import { wifiTransactionType } from '../../components/common/Helpers/constants';
import { PageList } from '../../constants/pageList';
import { getResumeCartPage } from '../../components/ResumeCart/resumeCartUtils';

export const dawCoupon = (data) => ({
  type: 'DAW_COUPON',
  value: data,
});

export const getDataFromApi = (data) => ({
  type: Constants.GET_DATA_FROM_API,
  data,
});
export const getUpdateCart = (data) => ({
  type: Constants.UPDATE_CART,
  data,
});
export const getSoi = (data) => ({
  type: 'GET_SOI',
  data,
});
export const intendType = () => {
  let intendTypeval = '';
  intendTypeval = getSession('FlowType');
  return intendTypeval;
};

export const bundleInstallType = () => {
  const bundleType = {
    installType: '',
    depletionType: '',
  };
  let i = 0;
  let lqResp = getSession('LQResponse');
  lqResp = JSON.parse(lqResp);
  if (lqResp && lqResp.output && lqResp.output.bundleDetails !== null && lqResp.output.bundleDetails !== undefined) {
    const { bundleDetails, launchType } = lqResp.output || {};
    if (bundleDetails.length > 1) {
      for (i = 0; i < bundleDetails.length; i++) {
        if (bundleDetails[i].type.toLowerCase() === 's') {
          bundleType.depletionType = 'F';
          bundleType.installType = bundleDetails[i].bundleName;
        }
      }
    } else if (bundleDetails.length === 1) {
      if (bundleDetails[i].type.toLowerCase() === 's') {
        bundleType.depletionType = 'F';
        bundleType.installType = bundleDetails[i].bundleName;
      } else {
        bundleType.installType = bundleDetails[0].bundleName;
        bundleType.depletionType = 'O';
      }
    } else if (bundleDetails.length === 0 && getSession('isCBandQual') === 'Y') {
      bundleType.depletionType = 'F';
    } else if (bundleDetails.length === 0 && launchType !== null && launchType !== undefined && launchType === '4GH') {
      bundleType.depletionType = 'F';
    } else if (bundleDetails.length === 0 && (lqResp.output.lteQualified || lqResp.output.qualified4GHome || lqResp.output.VHILiteQualified)) {
      bundleType.depletionType = 'F';
    }
  } else if (
    lqResp &&
    lqResp.output &&
    lqResp.output.launchType !== null &&
    lqResp.output.launchType !== undefined &&
    lqResp.output.launchType === '4GH'
  ) {
    bundleType.depletionType = 'F';
  } else if (lqResp && lqResp.output && lqResp.output.qualifiedCBand) {
    bundleType.depletionType = 'F';
  } else if (getSession('isCBandQual') === 'Y') {
    bundleType.depletionType = 'F';
  } else if (lqResp && lqResp.output && (lqResp.output.lteQualified || lqResp.output.qualified4GHome || lqResp.output.VHILiteQualified)) {
    bundleType.depletionType = 'F';
  } else if (lqResp && lqResp.tanglewoodQualified && lqResp.output.bundleDetails?.length > 0) {
    bundleType.depletionType = 'O';
    bundleType.installType = lqResp.bundleDetails[0].bundleName;
  }
  return bundleType;
};

export const getCheckAvilablityAPI = (postData) => {
  const apiURL = `${getSecureBaseUrl()}${apiUrls().updateCartOnAddons}`;
  const apiResponse = HttpService.post(apiURL, postData);
  Promise.all([apiResponse]).then((res) => {
    if (res[0] && res[0].data && res[0].status === 200) {
      return res[0].data;
    }
    logError('getCheckAvilablityAPI', res[0].errors, FE_API_ERROR);
    return null;
  });
};

export const partnerCheckAvlAPI = (postData) => {
  const apiURL = `${getSecureBaseUrl()}${apiUrls().partnerCheckAvlUrl}`;
  const reqData = {
    address: postData,
    includeCband: true,
    cBandOnly: false,
  };
  const apiResponse = HttpService.post(apiURL, reqData);
  Promise.all([apiResponse]).then((res) => {
    if (res[0] && res[0].data && res[0].status === 200) {
      store.dispatch({ type: Constants.PARTNER_AVL, response: res[0].data });
      window.location.href = PageList.FIVEG_HOME;
      return res[0].data;
    }
    logError('partnerCheckAvlAPI', FE_API_ERROR);
    return null;
  });
};

export const redirectTo = (url, history) => {
  if (history?.push && (window?.vzFlags?.isSPARedirectionEnabled || getSession('isSPARedirectionEnabled'))) {
    history.push(url);
  } else {
    window.location.href = url;
  }
};
export const getSoiAPI = () => {
  const postData = {
    source: 'getSoi',
    serviceRequest: {
      globalId: getCookie('GLOBALID'),
      insightCategory: ['loopqual'],
      insightName: ['vzosel'],
      additionalParams: {},
    },
  };
  const apiURL = `${getSecureBaseUrl()}${apiUrls().abandonCart}`;
  return HttpService.post(apiURL, postData);
};

export const getUpdateCartAPI = (inputData, flowType) => {
  const bundleInfo = bundleInstallType();
  const action = inputData && inputData.data && 'actionType' in inputData.data ? inputData.data.actionType : '';
  const history = inputData?.data?.history;
  let postData = {};
  const { search } = window.location;
  const params = new URLSearchParams(search);
  const isAddPlan = params.get('addplan') === 'false';
  const { wifiDisplay = '' } = inputData?.data || {};
  if (getAPPID() === 'AAL' && isBulkQualIndicator()) {
    if (flowType === 'EUP_LTE') {
      postData = {
        cartInfo: {
          clientAppName: '',
          bulkQualIndicator: 'Y',
          accountNumber: '',
          cartCreator: '',
          processingMTN: '',
          processStep: 'OrderNow',
          processAction: 'DeviceAndPlan',
          intendType: 'EUP_LTE',
          bundleInstallType: '',
        },
        data: {
          lines: [
            {
              depletionType: 'F',
            },
          ],
        },
      };
    } else {
      postData = getCartUpdtApiObj(bundleInfo, action);
      postData.cartInfo.bulkQualIndicator = 'Y';
    }
  } else if (flowType === 'EUP_LTE') {
    postData = {
      cartInfo: {
        clientAppName: '',
        accountNumber: '',
        cartCreator: '',
        processingMTN: '',
        processStep: 'OrderNow',
        processAction: 'DeviceAndPlan',
        intendType: 'EUP_LTE',
        bundleInstallType: '',
        ...(isSequentialFlow() && getAPPID() === 'NSE' ? { isSequentialComboOrder: true } : {}),
      },
      data: {
        lines: [
          {
            depletionType: 'F',
          },
        ],
      },
    };
  } else {
    postData = getCartUpdtApiObj(bundleInfo, action);
  }

  if (wifiDisplay && wifiTransactionType) {
    postData.data.lines[0].transactionType = wifiTransactionType;
    postData.data.lines[0].depletionType = 'F';
    postData.cartInfo.transactionType = wifiTransactionType;
  }

  postData.midnight = 'Y';

  const apiURL = `${getSecureBaseUrl()}${apiUrls().updateCartOnAddons}`;
  const apiResponse = HttpService.post(apiURL, postData);
  const isLoggedIn = getAPPID() === 'AAL';

  Promise.all([apiResponse]).then((res) => {
    store.dispatch({ type: 'CLEAR_COUPON_VALUE' });
    if (res[0] && res[0].data && res[0].status === 200 && !res[0].data?.errors) {
      if (flowType === 'EUP_LTE') {
        setSession('EUPUpgrade', true);
      }
      const responseContext = res[0]?.data?.serviceBody?.serviceResponse?.context;
      const { cartInfo, customerInfo, contextInfo } = responseContext || {};

      const existingCase = customerInfo?.existingCase ? customerInfo.existingCase : '';
      const processStep = contextInfo?.processStep ? contextInfo.processStep : '';
      const pastDue = contextInfo?.pastDueBalance ? contextInfo.pastDueBalance : '';
      const pastDueBalance = contextInfo?.pastDueBalanceAmount ? contextInfo.pastDueBalanceAmount : '';

      const cartExist = cartInfo?.cartExist ? cartInfo.cartExist : '';
      handleStreamlineSession(res[0]);
      setSession('ExistingCase', existingCase);
      setSession('cartExist', cartExist);
      setCookie('cartExist', cartExist);

      const reasonCode = cartInfo?.orderRestrictions?.accountLevelChangeEligibility ? cartInfo.orderRestrictions.accountLevelChangeEligibility : [];
      const reasonCodevalue = reasonCode.length > 0 && reasonCode[0]?.reasonCode;
      store.dispatch({ type: 'CBAND_STALL', response: res[0]?.data?.serviceBody?.serviceResponse?.context?.featureFlags?.cBandStalledSectorFFlag});
      store.dispatch({ type: 'CLEAR_COUPON_VALUE' });
      if (pastDue === 'true' || pastDue === true) {
        setSession('pastDueBalAmount', pastDueBalance);
        hideLoader(store.dispatch);
        window.location.href = apiUrls().accFailurl;
        return res[0].data;
      }
      if (reasonCodevalue === 'COLLECTIONS_IND') {
        hideLoader(store.dispatch);
        window.location.href = apiUrls().collections_INDurl;
        return res[0].data;
      }
      if (reasonCodevalue === 'CASHONLY_IND') {
        hideLoader(store.dispatch);
        window.location.href = apiUrls().cashOnlyUrl;
        return res[0].data;
      }
      if (reasonCodevalue === 'FRAUD_INDICATOR_X') {
        hideLoader(store.dispatch);
        window.location.href = apiUrls().ONFraudOrderUrl;
        return res[0].data;
      }
      store.dispatch({ type: 'GET_NPA_NXX_SUCCESS', response: '' });
      store.dispatch({ type: 'SHIPPING_ADDRESS_CHANGE', data: false });
      store.dispatch({ type: 'SHIPPING_ADDRESS_RADIO_SELECTED', data: '' });
      if ((existingCase === 'true' || existingCase === true) && params.get('fcc') !== 'y') {
        if (isAddPlan) {
          redirectTo(PageList.PROGRESSIVE_PLAN, history);
          return res[0].data;
        }
        if (isLoggedIn) {
          setSession('ExistingCase', existingCase);
        }
        redirectTo(processStepRedirection(processStep), history);
        return res[0].data;
      }
      if (action && action === 'Resume' && params.get('fcc') !== 'y') {
        store.dispatch({ type: 'VALIDATECART_RESPONSE', response: '' });
        store.dispatch({ type: 'CLEAR_COUPON_VALUE' });
        if(inputData?.barCodeOfferId) {
          store.dispatch({type: "BAR_CODE_RESUME_CALLBACK", data: {processStep, offerID: inputData.barCodeOfferId, history}});
          return;
        }
        redirectTo(processStepRedirection(processStep), history);
        return res[0].data;
      }
      setSession('ONResponse', JSON.stringify(res[0].data));
      setTimeout(() => {
        hideLoader(store.dispatch);
      }, 3000);
      const streamlineMVP2 = window.sessionStorage.getItem('widgetLQHost') === 'Streamline';
      if (getSession('isCBandFlow') === 'Y' && params.get('WHW') !== 'Y' && params.get('fcc') !== 'y') {
        redirectTo(streamlineMVP2 ? PageList.STREAMLINE_ORDER : PageList.PROGRESSIVE_PLAN, history);
        return res[0].data;
      }
      if (isWHW() || isWHWP2()) {
        redirectTo(apiUrls().redirectShipping, history);
        return res[0].data;
      }
      if (getSession('fcc') === 'true' || params.get('fcc') === 'y') {
        setSession('fcc', true);
        setCookie('fcc', true);
        window.location.href = apiUrls().redirectBroadBandFacts;
        return res[0].data;
      }
      if (isWWM()) {
        redirectTo(apiUrls().redirectShipping, history);
        return res[0].data;
      }
      redirectTo(streamlineMVP2 ? PageList.STREAMLINE_ORDER : PageList.PROGRESSIVE_PLAN, history);
      return res[0].data;
    }

    // se=r means sessionexpiry=redirect
    if (res?.[0]?.data?.errors?.[0]?.message?.includes('FiveG qualified address is not available')) {
      window.location.href = `${PageList.FIVEG_HOME}?se=r`;
    }

    if (res[0]?.status !== 200 || res[0]?.data?.errors) {
      store.dispatch({ type: Constants.UPDATE_CART_FAIL_RESPONSE, response: res[0] });
      store.dispatch({ type: Constants.UPDATE_CART_FAIL, response: true });
    }
    logError('getUpdateCartAPI', res[0].errors, FE_API_ERROR);
    setTimeout(() => {
      hideLoader(store.dispatch);
    }, 3000);
    return null;
  });
};

export const updateCartAPICall = () => {
  const isStreamline = window.sessionStorage.getItem('widgetLQHost') === 'Streamline';
  const postData = {
    cartInfo:{
      accountNumber: '',
      bundleInstallType: `${bundleInstallType().installType}`,
      cartCreator: '',
      cartId: '',
      caseId: '',
      clientAppName: 'VZW-DOTCOM',
      enableResume:'true',
      intendType: `${getIntendType()}`,
      processAction: isStreamline ? 'DeviceAndStreamLinePlan' : 'DeviceAndPlan',
      processStep: 'pastDuePage',
      processingMTN: '',
      transactionType: '',
      pastDueAccepted: 'Y',
    },
    data:{
      lines: [
        {
          transactionType: '',
          depletionType: `${bundleInstallType().depletionType}`,
        },
      ],
    },
  }   
  

  const apiURL = `${getSecureBaseUrl()}${apiUrls().updateCartOnAddons}`;
  return HttpService.post(apiURL, postData);
};

export const getCartUpdtApiObj = (bundleInfo, action) => {
 
  const postData = action
    ? {
        cartInfo: {
          clientAppName: 'VZW-DOTCOM',
          // bulkQualIndicator: 'Y',
          accountNumber: '',
          cartCreator: '',
          processingMTN: '',
          processStep: 'OrderNow',
          processAction: 'DeviceAndPlan',
          action,
          intendType: `${getIntendType()}`,
          streamLineFlow: `${skipProspectExpressCheckout()}`,
          bundleInstallType: bundleInfo?.installType ? bundleInfo.installType : null,
          ...(isSequentialFlow() && getAPPID() === 'NSE' ? { isSequentialComboOrder: true } : {}),
          ...(isJointTransactionFlow() ? { jointCombo: 'Y' } : {}),
        },
        data: {
          lines: [
            {
              depletionType: bundleInfo.depletionType,
            },
          ],
        },
      }
    : {
        cartInfo: {
          clientAppName: 'VZW-DOTCOM',
          // bulkQualIndicator: 'Y',
          accountNumber: '',
          cartCreator: '',
          processingMTN: '',
          processStep: 'OrderNow',
          processAction: 'DeviceAndPlan',
          intendType: `${getIntendType()}`,
          streamLineFlow: `${skipProspectExpressCheckout()}`,
          bundleInstallType: bundleInfo && bundleInfo.installType ? bundleInfo.installType : null,
          ...(isSequentialFlow() && getAPPID() === 'NSE' ? { isSequentialComboOrder: true } : {}),
          ...(isJointTransactionFlow() ? { jointCombo: 'Y' } : {}),
        },
        data: {
          lines: [
            {
              depletionType: bundleInfo.depletionType,
            },
          ],
        },
      };

  return postData;
};
export const processStepRedirection = (nextStep) => {
  saveItemToStore('isResumeFlow', true);
  setSession('ResumeCase', true);
  const isStreamline = window.sessionStorage.getItem('widgetLQHost') === 'Streamline';
  return getResumeCartPage(nextStep, false, isStreamline);
};
export const handleStreamlineSession = (updateResp) => {
  const hasPlanSelection = updateResp?.data?.serviceBody?.serviceResponse?.context?.processMTNList?.some((item) =>
    item?.completedprocessSteps?.includes('StreamLinePlanSelection'),
  );
  const isDirectFlow = window.sessionStorage.getItem('direcFlowLQ') === 'Y';
  if (getAPPID() === 'NSE' && hasPlanSelection && isDirectFlow) {
    window.sessionStorage.setItem('widgetLQHost', 'Streamline'); // for streamline ordering pages internal redirections
  }
};
export const getRedirectToAPI = () => {
  const apiURL = `${getSecureBaseUrl()}${apiUrls().reDirectToUrl}`;
  const reqData = {};
  const apiResponse = HttpService.post(apiURL, reqData);
  Promise.all([apiResponse]).then((res) => {
    if (res[0] && res[0].data && res[0].status === 200) {
      return res[0].data;
    }
    logError('getRedirectToAPI', res[0].errors, FE_API_ERROR);
    return null;
  });
};

export const getRedirectAPI = () => {
  const apiURL = `${getSecureBaseUrl()}${apiUrls().reDirectToUrl}`;
  const reqData = {};
  const apiResponse = HttpService.post(apiURL, reqData);
  Promise.all([apiResponse]).then((res) => {
    if (res && res[0] && res[0].data && res[0].data.redirectUrl) {
      window.location.href = res[0].data.redirectUrl;
    }
    logError('getRedirectAPI', FE_API_ERROR);
    return null;
  });
};

export const getData = () => HttpService.get(`${getSecureBaseUrl()}${apiUrls().basetemplateurl}`);

export const pushMessageCall = (data) => ({
  type: Constants.PUSH_MESSAGE_CALL,
  data,
});

export const pushMessageApiCall = () => {
  const postData = {
    type: 'coverageLead',
  };
  const apiURL = `${getSecureBaseUrl()}${apiUrls().pushMessage}`;
  return HttpService.post(apiURL, postData);
};

export const getFeatureFlags = (profileDetails) => {
  const apiURL = `${getSecureBaseUrl()}${apiUrls().getFeatureFlags}`;
  const postData = {profileRequestList: profileDetails}
  return HttpService.post(apiURL, postData);
}
